<template>
  <div class="animate-fade-in font-sans selection:bg-carpatina-portocaliu selection:text-white">
    
    <section class="bg-carpatina-verde py-16 px-4 text-center text-white relative overflow-hidden">
      <div class="absolute top-0 left-0 p-8 opacity-10 pointer-events-none">
        <ShoppingCart :size="150" />
      </div>
      <h1 class="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4 relative z-10">Cerere de Ofertă</h1>
      <p class="text-lg opacity-80 max-w-2xl mx-auto italic relative z-10">
        Lasă-ne datele tale și lista de materiale dorite. Revenim la tine în cel mai scurt timp cu prețurile și costul transportului!
      </p>
    </section>

    <section class="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
      
      <div class="space-y-8 flex flex-col">
        <div>
<div class="flex items-center justify-between mb-6">
            <h3 class="text-2xl font-black text-carpatina-gri uppercase flex items-center gap-3">
              <span class="bg-carpatina-portocaliu w-2 h-8 block"></span> Lista Ta
              <span class="bg-orange-50 text-carpatina-portocaliu text-sm px-3 py-1 rounded-xl ml-2">{{ cart.totalItems }} Produse</span>
            </h3>

            <button v-if="cart.items.length > 0" 
                    @click="confirmClearCart"
                    class="text-xs font-bold uppercase text-gray-400 hover:text-red-500 transition flex items-center gap-1 group">
              <Trash2 :size="14" class="group-hover:animate-bounce" /> Golește
            </button>
          </div>

          <div v-if="cart.items.length === 0" class="bg-gray-50 p-10 rounded-3xl text-center border-2 border-dashed border-gray-200">
            <PackageX :size="48" class="text-gray-300 mx-auto mb-4" />
            <p class="text-carpatina-gri font-black uppercase text-sm mb-2">Lista este goală</p>
            <p class="text-xs text-gray-500 italic mb-6">Nu ai adăugat niciun material pentru ofertare.</p>
            <router-link to="/produse" class="bg-carpatina-verde text-white text-xs font-black uppercase px-6 py-3 rounded-xl hover:bg-carpatina-portocaliu transition">
                Vezi Catalogul
            </router-link>
          </div>

          <div v-else class="space-y-4 max-h-[500px] overflow-y-auto custom-scrollbar pr-2">
            <div v-for="item in cartItemsWithDetails" :key="item.productId" 
                 class="bg-white p-3 rounded-2xl shadow-md border border-gray-100 flex items-center gap-4 group transition hover:border-carpatina-portocaliu">
              
              <div class="w-16 h-16 rounded-xl bg-gray-100 overflow-hidden shrink-0 flex items-center justify-center">
                <img v-if="item.poza" :src="'https://carpatinaprodcom.ro/api' + item.poza" class="w-full h-full object-cover">
                <Package v-else :size="20" class="text-gray-300" />
              </div>

              <div class="flex-1 min-w-0">
                <h4 class="text-xs font-black text-carpatina-gri uppercase truncate" :title="item.nume">{{ item.nume }}</h4>
                <div class="flex items-center gap-3 mt-2">
                    
                    <div class="flex items-center bg-gray-50 rounded-lg border border-gray-200">
                        <button @click="cart.update(item.productId, item.quantity - 1)" class="w-7 h-7 flex items-center justify-center text-gray-500 hover:text-carpatina-portocaliu transition">
                            <Minus :size="12" stroke-width="3" />
                        </button>
                        <span class="w-8 text-center text-xs font-black text-carpatina-gri">{{ item.quantity }}</span>
                        <button @click="cart.update(item.productId, item.quantity + 1)" class="w-7 h-7 flex items-center justify-center text-gray-500 hover:text-carpatina-portocaliu transition">
                            <Plus :size="12" stroke-width="3" />
                        </button>
                    </div>

                    <button @click="cart.remove(item.productId)" class="text-gray-300 hover:text-red-500 transition ml-auto" title="Șterge produs">
                        <Trash2 :size="16" />
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-carpatina-gri p-6 rounded-3xl text-white shadow-xl mt-auto">
          <p class="font-black uppercase text-xs mb-3 tracking-widest text-carpatina-portocaliu flex items-center gap-2">
             <Info :size="16" /> Informație Utilă
          </p>
          <p class="text-xs opacity-80 leading-relaxed italic">
            Acesta este un calculator de necesar. Prețurile finale vor fi calculate în funcție de cantitate și distanța de livrare către localitatea ta.
          </p>
        </div>
      </div>

      <div class="lg:col-span-2 bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-b-8 border-carpatina-portocaliu">
        <h3 class="text-3xl font-black text-carpatina-verde uppercase mb-8 tracking-tighter">Datele Tale</h3>
        
        <form @submit.prevent="handleCerere" class="space-y-6">
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Nume Complet <span class="text-red-500">*</span></label>
              <div class="relative">
                <User class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.nume" required type="text" placeholder="Ex: Ion Popescu"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition font-bold text-sm text-carpatina-gri">
              </div>
            </div>

            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Număr Telefon <span class="text-red-500">*</span></label>
              <div class="relative">
                <Phone class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.telefon" required type="tel" placeholder="07xx xxx xxx"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition font-bold text-sm text-carpatina-gri">
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Localitate (Oraș / Sat) <span class="text-red-500">*</span></label>
              <div class="relative">
                <MapPin class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.localitate" required type="text" placeholder="Ex: Turnu Măgurele"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition font-bold text-sm text-carpatina-gri">
              </div>
            </div>

            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Email (Opțional)</label>
              <div class="relative">
                <AtSign class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.email" type="email" placeholder="email@exemplu.ro"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition font-bold text-sm text-carpatina-gri">
              </div>
            </div>
          </div>

          <div class="space-y-2">
            <label class="text-xs font-black uppercase text-gray-400 ml-1">Mențiuni Descărcare / Detalii Produse</label>
            <div class="relative">
              <MessageSquare class="absolute left-3 top-4 text-gray-300" :size="20" />
              <textarea v-model="form.mentiuni" rows="4" placeholder="Ex: Vreau țeava de 30X30X2MM 2 bucați si una de 20x20x2MM, accesul e pe o stradă îngustă..."
                        class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition font-bold text-sm text-carpatina-gri"></textarea>
            </div>
          </div>
          <div class="hidden" aria-hidden="true">
            <input v-model="honeypot" type="text" name="website_url" tabindex="-1" autocomplete="off">
          </div>
          <button type="submit" :disabled="loading || cart.items.length === 0"
                  class="w-full bg-carpatina-verde hover:bg-carpatina-portocaliu text-white font-black py-5 rounded-2xl shadow-lg transition-all transform hover:-translate-y-1 disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:bg-carpatina-verde active:scale-95 flex items-center justify-center gap-3 uppercase tracking-widest mt-4">
            <Send v-if="!loading" :size="20" />
            <span>{{ loading ? 'Se procesează...' : 'Trimite Cererea de Ofertă' }}</span>
          </button>
          
        </form>
      </div>

    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import Swal from 'sweetalert2';
import { 
  User, Phone, MapPin, AtSign, MessageSquare, Send, 
  ShoppingCart, Package, Trash2, Plus, Minus, Info, PackageX
} from 'lucide-vue-next';

// Injects & Router
const cart = inject('cart');
const router = useRouter();

// State
const loading = ref(false);
const produseCatalog = ref([]); 
// State suplimentar pentru securitate
const honeypot = ref('');
const loadTime = ref(Date.now());
const form = ref({
  nume: '',
  telefon: '',
  localitate: '',
  email: '',
  mentiuni: ''
});

onMounted(async () => {
  document.title = "Finalizare Cerere Ofertă | Carpatina Prodcom";

  // Aducem toate produsele din DB ca să putem face "match" cu ID-urile din coș 
  // pentru a le afișa poza și numele frumos în UI.
  try {
    const res = await axios.get('/produse');
    produseCatalog.value = res.data;
  } catch (err) {
    console.error("Eroare la aducerea produselor pentru coș:", err);
  }
});

// Computed: Mapează ID-urile din LocalStorage cu numele/poza din catalog
const cartItemsWithDetails = computed(() => {
  return cart.items.map(cartItem => {
    const prod = produseCatalog.value.find(p => p.id === cartItem.productId);
    return {
      ...cartItem,
      nume: prod ? prod.nume : 'Se încarcă...',
      poza: prod && prod.poze && prod.poze.length ? prod.poze[0].url : null
    };
  });
});
  // Golire completă coș (cu confirmare)
  const confirmClearCart = () => {
  Swal.fire({
    title: 'Ești sigur?',
    text: "Toate materialele vor fi șterse din listă!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444', // roșu pentru ștergere
    cancelButtonColor: '#9ca3af', // gri
    confirmButtonText: 'Da, golește!',
    cancelButtonText: 'Anulează'
  }).then((result) => {
    if (result.isConfirmed) {
      cart.clear(); // Aici apelăm funcția clear() din starea ta globală
    }
  });
  };
// Submit
// Modifică handleCerere
const handleCerere = async () => {
  // 1. Verificare Honeypot (Dacă e completat, ignorăm silențios botul)
  if (honeypot.value !== '') {
    console.warn("Bot detectat prin honeypot.");
    return;
  }

  // 2. Verificare Timp (Dacă a durat sub 3 secunde să completeze tot, probabil e bot)
  const timeElapsed = Date.now() - loadTime.value;
  if (timeElapsed < 3000) {
    Swal.fire('Eroare securitate', 'Te rugăm să mai aștepți o secundă înainte de a trimite.', 'warning');
    return;
  }

  if (cart.items.length === 0) {
    Swal.fire('Eroare', 'Lista de ofertă este goală.', 'warning');
    return;
  }

  loading.value = true;
  
  // Construim exact payload-ul JSON cerut de Pydantic
  const payload = {
    client: {
      nume: form.value.nume,
      localitate: form.value.localitate,
      telefon: form.value.telefon,
      email: form.value.email || null,
      mentiuni: form.value.mentiuni || null
    },
    cart: cart.items.map(i => ({
        productId: i.productId,
        quantity: i.quantity
    }))
  };

  try {
    // Trimitem cu axios.post direct JSON-ul (nu folosim FormData aici)
    await axios.post('/cerere-oferta', payload);
    
    Swal.fire({
      title: 'Cerere Trimisă!',
      text: 'Am primit lista ta. Te vom contacta în scurt timp!',
      icon: 'success',
      confirmButtonColor: '#00684a'
    }).then(() => {
      cart.clear(); // Golim coșul
      router.push('/'); // Trimitem omul pe prima pagină
    });

  } catch (err) {
    console.error("Eroare trimitere:", err);
    Swal.fire('Eroare', 'Nu am putut trimite cererea. Încearcă să ne suni la 0247 412 068.', 'error');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.5s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

/* Custom scrollbar pentru lista de produse (dacă pune multe) */
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 10px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #f08119; }
</style>